import client from '@/api/client'
import { notifyError } from '@/utils/appstore'
import { LocationSetting } from '@/pages/appstore/entities/locations'

export async function getCustomFields() {
    const response = await client.get(`/appstore/locations/get-custom-fields`)

    return response.data
}

export async function createNewCustomField(locationData: any) {
    try {
        const { data } = await client.post(
            '/appstore/locations/create-new-custom-field',
            locationData
        )
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}

export async function saveLocation(location: any) {
    try {
        const { data } = await client.post(
            '/appstore/locations/save-location',
            location
        )
        return data
    } catch (e: any) {
        if (e.response.status === 400) {
            notifyError(`Error: ${e.response.data.message}`)
        } else {
            notifyError(`Something went wrong: ${e.response.data.message}`)
        }
    }
}

export async function editLocation(location: any) {
    try {
        const { data } = await client.patch(
            '/appstore/locations/edit-location',
            location
        )
        return data
    } catch (e: any) {
        if (e.response.status === 400) {
            notifyError(`Error: ${e.response.data.message}`)
        } else {
            notifyError(`Something went wrong: ${e.response.data.message}`)
        }
    }
}

export async function getCustomFieldValues(customFieldName: any) {
    try {
        const { data } = await client.post(
            '/appstore/locations/get-custom-field-values',
            customFieldName,
            {
                headers: { 'Content-Type': 'text/plain' }, // Force it to pass as string so quotes are not added by JSON encoding
            }
        )
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}

export async function getLocations() {
    try {
        const { data } = await client.get('/appstore/locations/get-locations')
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}

export async function getNotificationRecipients() {
    try {
        const { data } = await client.get(
            '/appstore/locations/get-notification-recipients'
        )
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}

export async function deleteLocation(locationId) {
    try {
        const { data } = await client.post(
            '/appstore/locations/delete-location',
            { id: locationId }
        )
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}

export async function getLocationField() {
    try {
        const { data } = await client.get(
            '/appstore/locations/get-location-field'
        )
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}

export async function saveLocationSetting(locationSetting: LocationSetting) {
    try {
        const { data } = await client.post(
            '/appstore/locations/save-location-setting',
            locationSetting
        )
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}
